import { render, staticRenderFns } from "./ValSectoresView.vue?vue&type=template&id=402234e3&"
import script from "./ValSectoresView.vue?vue&type=script&lang=js&"
export * from "./ValSectoresView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports